import _classCallCheck from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ThemeDefault } from "./ThemeDefault";
import { deepExtend } from "../../../Utils";
export var Theme = /*#__PURE__*/function () {
  function Theme() {
    _classCallCheck(this, Theme);

    this.name = "";
    this.default = new ThemeDefault();
  }

  _createClass(Theme, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.name !== undefined) {
        this.name = data.name;
      }

      this.default.load(data.default);

      if (data.options !== undefined) {
        this.options = deepExtend({}, data.options);
      }
    }
  }]);

  return Theme;
}();